export function getLogScale(value, minp=0, maxp=256, minv=1, maxv=10) {
    // position will be between 0 and 100
    
    // The result should be between 100 an 10000000
    minv = Math.log(minv);
    maxv = Math.log(maxv);
    
    // calculate adjustment factor
    var scale = (maxv-minv) / (maxp-minp);
    
    return Math.exp(minv + scale*(value-minp));
}
